import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const HowItWorksPage = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* NAVBAR */}
      <Navbar />

      {/* MAIN */}
      <main className="flex-1">
        <section className="container mx-auto max-w-5xl px-4 py-12">

          {/* CARD */}
          <div className="rounded-2xl border border-border bg-card p-6 md:p-10 shadow-sm">

            {/* HEADER */}
            <div className="mb-10">
              <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground">
                How Deal<span className="text-primary">Swapify</span> Works
              </h1>

              <p className="mt-4 text-muted-foreground max-w-3xl">
                DealSwapify makes it simple to buy, sell, donate, and exchange
                items within your community using a modern real-time marketplace.
              </p>
            </div>

            {/* STEPS */}
            <div className="space-y-6">

              {/* STEP 1 */}
              <div className="rounded-xl border border-border bg-secondary p-5">
                <div className="flex items-center gap-4">

                  <div className="h-10 w-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">
                    1
                  </div>

                  <div>
                    <h2 className="text-xl font-semibold">
                      Create an Account
                    </h2>

                    <p className="mt-2 text-sm text-muted-foreground">
                      Sign up and create your marketplace profile to begin
                      buying, selling, donating, or chatting with other users.
                    </p>
                  </div>

                </div>
              </div>

              {/* STEP 2 */}
              <div className="rounded-xl border border-border bg-secondary p-5">
                <div className="flex items-center gap-4">

                  <div className="h-10 w-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">
                    2
                  </div>

                  <div>
                    <h2 className="text-xl font-semibold">
                      Post an Item
                    </h2>

                    <p className="mt-2 text-sm text-muted-foreground">
                      Upload item images, descriptions, pricing, pickup
                      locations, and availability periods to create a listing.
                    </p>
                  </div>

                </div>
              </div>

              {/* STEP 3 */}
              <div className="rounded-xl border border-border bg-secondary p-5">
                <div className="flex items-center gap-4">

                  <div className="h-10 w-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">
                    3
                  </div>

                  <div>
                    <h2 className="text-xl font-semibold">
                      Browse Categories
                    </h2>

                    <p className="mt-2 text-sm text-muted-foreground">
                      Explore different categories such as electronics,
                      furniture, books, clothes, tools, vehicles, and more.
                    </p>
                  </div>

                </div>
              </div>

              {/* STEP 4 */}
              <div className="rounded-xl border border-border bg-secondary p-5">
                <div className="flex items-center gap-4">

                  <div className="h-10 w-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">
                    4
                  </div>

                  <div>
                    <h2 className="text-xl font-semibold">
                      Chat in Real Time
                    </h2>

                    <p className="mt-2 text-sm text-muted-foreground">
                      Contact buyers or sellers instantly using the built-in
                      marketplace messaging system.
                    </p>
                  </div>

                </div>
              </div>

              {/* STEP 5 */}
              <div className="rounded-xl border border-border bg-secondary p-5">
                <div className="flex items-center gap-4">

                  <div className="h-10 w-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">
                    5
                  </div>

                  <div>
                    <h2 className="text-xl font-semibold">
                      Receive Notifications
                    </h2>

                    <p className="mt-2 text-sm text-muted-foreground">
                      Get notified when someone messages you or when important
                      marketplace activity happens.
                    </p>
                  </div>

                </div>
              </div>

              {/* STEP 6 */}
              <div className="rounded-xl border border-border bg-secondary p-5">
                <div className="flex items-center gap-4">

                  <div className="h-10 w-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">
                    6
                  </div>

                  <div>
                    <h2 className="text-xl font-semibold">
                      Mark Items as Sold
                    </h2>

                    <p className="mt-2 text-sm text-muted-foreground">
                      Once an item has been sold or completed, you can mark it
                      as sold directly from your profile.
                    </p>
                  </div>

                </div>
              </div>

            </div>

            {/* SAFETY */}
            <div className="mt-10 rounded-2xl border border-border bg-secondary p-6">

              <h2 className="text-2xl font-semibold mb-3">
                Safety Tips
              </h2>

              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Meet in safe public places</li>
                <li>Verify item details before payment</li>
                <li>Avoid sharing sensitive information</li>
                <li>Report suspicious users or activity</li>
              </ul>

            </div>

          </div>

        </section>
      </main>

      {/* FOOTER */}
      <Footer />
    </div>
  );
};

export default HowItWorksPage;